import React, { useState } from "react";
import "./FAQ.css";
import { FaPlus, FaMinus } from "react-icons/fa";

const FAQ = ({ faqData }) => {
  return (
    <div className="faq">
      {faqData.map((category, idx) => (
        <div key={idx} className="faq-category">
          <h2>{category.category}</h2>
          {category.questions.map((q, i) => (
            <FAQItem key={i} question={q.question} answer={q.answer} />
          ))}
        </div>
      ))}
    </div>
  );
};

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`faq-item ${isOpen ? "open" : ""}`}>
      <div className="faq-question" onClick={() => setIsOpen(!isOpen)}>
        <h4>{question}</h4>
        <span>{isOpen ? <FaMinus /> : <FaPlus />}</span>
      </div>
      {isOpen && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

export default FAQ;
